import { ModalService } from '@shopping-angular-components/modal';
import { ScreenType } from 'projects/common/model/ScreenType';
import { Component, Injector, Input, OnInit, OnDestroy, ViewEncapsulation, ViewChild, ElementRef, ViewChildren, QueryList, AfterViewInit, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { Currency, LandingModel } from 'projects/common/model/landingModel';
import { LandingModelService } from 'projects/common/services/landingModel.service';
import { KeyValue } from '@angular/common';
import { FiltersService } from 'projects/common/services/filters.service';
import { AbstractComponent } from '../abstract.component';
import { OffersFiltersModalContentComponent } from './offers-filters-content.component';
import { DiscreteFilter, Filter, FilterType, OffersFilterData } from './offers-filters-model';
import { TranslateService } from '@ngx-translate/core';
import { UpaTarget } from 'projects/common/services/upa.service';
import { UtilsService } from '../../services/utils.service';
import { Module } from 'projects/common/model/ModuleModel';
import { TooltipComponent } from '@shopping-angular-components/tooltip';
import { ConfirmButtonsComponent } from '../confirm-buttons/confirm-buttons.component';
import { ThousandsSeparatorPipe } from 'projects/common/pipes/thousands-separator.pipe';
import { PriceAlertsService } from 'projects/common/services/price-alerts.service';
import { SortingModalContentComponent } from '../sorting-select/sorting-modal-content.component';

@Component({
  selector: 'offers-filters',
  template: `
    <div  *ngIf="isDesktop else mobile" class="horizontal-scroll">

      <div *ngIf="(module.data.filters | keyvalue)?.length"
        class="filter-buttons -eva-3-shadow-line -eva-3-shadow-static -eva-3-bc-white"
        [ngClass]="{'with-scroll': isDesktop && module.data.use_modal}">

        <div *ngIf="cityFilter.showCity" class="-eva-3-mr-sm filter-origin">
          <em>{{"common.departingFrom" | translate}}</em>:
          <em class="-eva-3-bold">{{cityFilter.cityName}}</em>
        </div>

        <sorting-select *ngIf="hasSortingOptions()" 
          [sortingOptions]="module.data.sorting_options"
          [useModal]="!isDesktop"
          [moduleId]="getModuleId()"
          [moduleIndex]="module.row_number"
          [uniqueId]="module.unique_id"
          (sortingChangeEvent)="onSortingChange($event)"></sorting-select>

        <span *ngIf="hasSortingOptions()" class="offer-filter-separator"></span>

        <div class="filter-tags" [ngClass]="{'scroll-container': isDesktop && module.data.use_modal}">
          <div #scrollContent class="filter-tags-wrapper"  [ngClass]="{'scroll-content': isDesktop && module.data.use_modal}" (scroll)="onScroll()">

            <div #leftArrow class="left arrow-container" (click)="onClickScrollLeft()" *ngIf="isDesktop && module.data.use_modal">
              <i name="<" class="eva-3-icon-chevron-left -on-hover left-arrow"></i>
            </div>



            <eva-tag *ngIf="module.data.use_modal" class="filter-all-pill"
              [text]="((this.isImprovedFiltersEnabled ? 'filters.name' : 'filters.all') | translate) + (filtersAppliedCount ? ' (' + filtersAppliedCount + ')' : '')"
              [active]="false"
              [icon]="'filter'"
              (clickEvent)="showFiltersModal('ALL_FILTERS')">
            </eva-tag>

            <eva-tag *ngFor="let groupId of groupedFilters | keyvalue"
              class="filter-group-pill"
              [text]="getGroupLabelText(groupId.key)"
              [active]="someGroupedFilterSelected(groupId.key)"
              (clickEvent)="showGroupedFilters(groupId.key)"
              (removeEvent)="removeGroupedFilter(groupId.key)">
            </eva-tag>

            <ng-container *ngIf="module.data.show_all_filters">

              <tooltip #tooltipComponent
                position='-bottom -right' class="columns-all" backgroundColor="-white"
                [openOnClick]="!module.data.use_modal" [closeOnOutsideClick]="true"
                flow="landing" product="nymeria-gui"
                >

                <div label class="tags-container">
                  <ng-container *ngFor="let filterEntry of module.data.filters | keyvalue : filtersService.filterOrder">
                    <ng-container *ngIf="filterEntry.value.search_type === 'CITY' && cityFilter.showCity; else nonCityFilter">
                      <span class="eva-3-link edit-origin"><i class="-eva-3-icon-xsm eva-3-icon-edit -eva-3-tc-brand-primary-3 -eva-3-mr-sm"></i>{{"filters.origin" | translate}}</span>
                    </ng-container>
                    <ng-template #nonCityFilter>
                      <eva-tag
                        *ngIf="((!filterEntry.value.hidden || filtersService.isForcedVisible(filterEntry.value.name)) || filterEntry.value.active)"
                        [text]="getLabelText(filterEntry)"
                        [active]="filterEntry.value.hasSelection"
                        [icon]="filterEntry.key === 'flexible_cancellation_policy' ? 'plus' : ''"
                        (clickEvent)="showFilters(filterEntry)"
                        (removeEvent)="removeFilter(filterEntry)">
                      </eva-tag>
                    </ng-template>
                  </ng-container>
                </div>

                <offers-filters-content tooltip-content
                  [showAll]="true"
                  [filters]="module.data.filters"
                  [currency]="currency"
                  [moduleIndex]="module.row_number"
                  [moduleId]="getModuleId()"
                  [uniqueId]="module.unique_id"
                  [isModal]="module.data.use_modal"
                  (applyFiltersEvent)="onApplyFilters()"
                  (removeFiltersEvent)="onRemoveFiltersEvent()">
                </offers-filters-content>

              </tooltip>
            </ng-container>

            <ng-container *ngIf="!module.data.show_all_filters">
              <tooltip #individualFilterTooltips *ngFor="let filterEntry of module.data.filters | keyvalue : filtersService.filterPillsOrder; let filterIndex = index"
                position='-bottom -right' backgroundColor="-white"
                [openOnClick]="!module.data.use_modal" [closeOnOutsideClick]="true"
                [ngClass]="needColumns(filterEntry) ? 'columns' : ''"
                flow="landing" product="nymeria-gui"
                >
                <eva-tag label
                  *ngIf="!filterEntry.value.group_id && ((!filterEntry.value.hidden || filtersService.isForcedVisible(filterEntry.value.name)) || filterEntry.value.active)"
                  [text]="getLabelText(filterEntry)"
                  [active]="filterEntry.value.active || filterEntry.value.hasSelection"
                  [icon]="filterEntry.key === 'flexible_cancellation_policy' ? 'plus' : ''"
                  (clickEvent)="showFilters(filterEntry)"
                  (removeEvent)="removeFilter(filterEntry)">
                </eva-tag>

                <offers-filters-content tooltip-content
                  [filters]="module.data.filters"
                  [criteria]="filterEntry.key"
                  [currency]="currency"
                  [moduleIndex]="module.row_number"
                  [moduleId]="getModuleId()"
                  [uniqueId]="module.unique_id"
                  [isModal]="module.data.use_modal"
                  (applyFiltersEvent)="onApplyFilters(filterIndex)">
                </offers-filters-content>

              </tooltip>


            </ng-container>


            <div #rightArrow class="right arrow-container" (click)="onClickScrollRight()" *ngIf="isDesktop && module.data.use_modal">
              <i name=">" class="eva-3-icon-chevron-right -on-hover right-arrow"></i>
            </div>
          </div>
        </div>

        <eva-button *ngIf="mapLink" [options]="{type: '-link', link_text: ('common.view-on-map.' + screenType) | translate, link: mapLink, icon: 'location'}"
          [newTab]="true" [moduleId]="getModuleId()" [moduleIndex]="module.row_number" [uniqueId]="module.unique_id"
          [nofollow]="true"></eva-button>

      </div>
    </div>
    <empty-state *ngIf="module.data.showEmptyState"
               [title]="{ tag: 'H3', 'text': ('empty-state.not-found' | translate)}"
               [moduleId]="getModuleId()"
               [moduleIndex]="module.row_number"
               [uniqueId]="module.unique_id"
               [text]="'empty-state.try-again' | translate"
               [button]="{ghost_button: false, type: '-primary', size: '-md', link_text: ('common.delete-filters' | translate)}"
               (clickEvent)="removeAllFilters()"></empty-state>

    <ng-template #mobile>
      <div class="mobile-floating-button FLOATING_ELEMENT">
        <div class="eva-3-order -eva-3-shadow-static">
          <div class="order-container">
            <div role="presentation" class="order-item" *ngIf="mapLink">
              <a class="order-link" [href]="mapLink" target="_blank" (click)="trackViewOnMap()">
                <i class="eva-3-icon-location  order-item-icon"></i>
                <span class="order-text">{{("common.view-on-map." + screenType) | translate}}</span>
              </a>
            </div>
            <div *ngIf="priceAlertsService.isEnabled && !priceAlertsService.alertCalled" role="presentation" class="order-item">
              <span class="order-link eva-3-link" (click)="onAlertButtonClick()">
                <i class="eva-3-icon-notification order-item-icon" ></i>
                <span class="order-text">{{"common.alert" | translate}}</span>
              </span>
            </div>
            <div role="presentation" class="order-item" *ngIf="hasSortingOptions()">
              <span class="order-link eva-3-link" (click)="showSortingModal()">
                <i class="eva-3-icon-order order-item-icon"></i>
                <span class="order-text">{{"common.sort" | translate}}</span>
              </span>
            </div>
            <div role="presentation" class="order-item">
              <span class="order-link eva-3-link" (click)="showFiltersModal()">
                <i class="eva-3-icon-filter order-item-icon" *ngIf="filtersAppliedCount === 0 else count"></i>
                <ng-template #count>
                  <span class="order-item-badge">
                    {{filtersAppliedCount}}
                  </span>
                </ng-template>
                <span class="order-text">{{"common.filter" | translate}}</span>
              </span>
            </div>

          </div>
        </div>
      </div>
    </ng-template>
  `,
  styleUrls: ['./offers-filters.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class OffersFiltersComponent extends AbstractComponent implements OnInit, OnChanges, OnDestroy, AfterViewInit {
  @Input() override module: Module<OffersFilterData>;
  @Input() currency: Currency;

  override screenType: ScreenType;
  filtersAppliedCount = 0;
  landingModel: LandingModel;
  modalFooterModel;
  groupedFilters: { [groupId: string]: { [key: string]: Filter } } = {};
  improvedFiltersEnabled = false;

  @ViewChild('tooltipComponent') tooltipComponent: TooltipComponent;
  @ViewChildren('individualFilterTooltips') individualFilterTooltips: QueryList<TooltipComponent>;

  @ViewChild('scrollContent') scrollContent: ElementRef;
  @ViewChild('rightArrow') rightArrow: ElementRef;
  @ViewChild('leftArrow') leftArrow: ElementRef;

  private distance: number = 150;

  selectedFilterLabels = {}
  cityFilter: {
    showCity?: boolean,
    cityName?: string
  }
  initialFilters: any;

  isDesktop = false;
  isWebview = false;

  mapLink: string;

  private subscriptions: any[] = [];

  constructor(injector: Injector,
    public override landingModelService: LandingModelService,
    protected modalService: ModalService,
    protected filtersService: FiltersService,
    private translateService: TranslateService,
    private thousandsSeparatorPipe: ThousandsSeparatorPipe,
    public priceAlertsService: PriceAlertsService) {

    super(injector);
    this.landingModel = this.landingModelService.getLandingModel();
    this.screenType = this.landingModel.device.type;
  }

  static resolveMapLinkFromDate(): string {
    const date = new Date();
    date.setMonth(date.getMonth() + 1);
    return date.toISOString().split('T')[0];
  }

  static resolveMapLinkToDate(): string {
    const date = new Date();
    date.setMonth(date.getMonth() + 1);
    date.setDate(date.getDate() + 1);
    return date.toISOString().split('T')[0];
  }

  ngOnInit(): void {
    this.initRangeFilters();
    this.initialFilters = JSON.parse(JSON.stringify(this.module.data.filters));
    this.improvedFiltersEnabled = this.landingModelService.getLandingModel().abTests?.ab.includes("nymeriaImprovedFilters|enabled_true");

    if (this.isImprovedFiltersEnabled && this.module?.data?.sorting_options) {
      this.filtersService.initializeSortingState(this.module.data.sorting_options, this.module.data.default_sorting_id);
    }

    this.filtersService.registerFilters(this.module.data.filters);

    this.selectedFilterLabels = this.filtersService.getSelectedFilterLabels();
    this.filtersAppliedCount = this.filtersService.countFiltersApplied();
    this.isDesktop = this.screenType === ScreenType.DESKTOP;
    this.isWebview = this.landingModelService.getLandingModel().webview;
    this.subscriptions.push(this.filtersService.filtersAppliedCountEvent
      .subscribe(({ count, filters }) => {
        this.filtersAppliedCount = count;
        this.module.data.filters = filters;
        this.selectedFilterLabels = this.filtersService.getSelectedFilterLabels();
        this.initGroupedFilters();
        setTimeout(() => this.onScroll(), 0);
      }));

    if (!this.isDesktop || this.module.data.use_modal) {
      this.subscriptions.push(this.filtersService.modalFilterSelectedEvent
        .subscribe(({ filters, hasChanges, selectionsCount }) => {
          const showRemove = selectionsCount > 0;
          const applyButtonLabel = selectionsCount > 0 ? 'common.applyFilters.' + (selectionsCount > 1 ? 'plural' : 'singular') : 'common.apply';
          this.modalFooterModel.modelChanges.emit({
            acceptLabel: this.translateService.instant(applyButtonLabel, { quantity: selectionsCount }),
            acceptButtonDisabled: !hasChanges,
            isCancelable: showRemove
          });
        }));
    }
    this.configMapLink();

    this.cityFilter = {
      showCity: this.module.data.show_origin,
      cityName: this.module.data.default_origin,
    }

    this.initGroupedFilters();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.initRangeFilters();
  }

  ngAfterViewInit() {
    this.onScroll();
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((s) => {
      s.unsubscribe();
    });
  }

  minutesToTime(totalMinutes: number): string {
    const hours = Math.floor(totalMinutes / 60);
    const minutes = Math.floor(totalMinutes % 60);
    return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')} ${this.translateService.instant('filters.range.hours')}`;
  }

  formatPrice(selectedValue: number): string {
    return `${this.currency.symbol} ${this.thousandsSeparatorPipe.transform(selectedValue, this.currency.thousandsSymbol)}`
  }

  initRangeFilters() {
    const rangeFilters = Object.entries(this.module.data.filters).filter(([key, filter]) => filter.type === 'range');
    rangeFilters.forEach(([key, filter]) => {
      if (filter.type === 'range') {
        if (filter.multiselector && !filter.values) {
          filter.values = [];
          Object.entries(filter.value).forEach(([key, filterValue]) => filter.values?.push({ [key]: filterValue }));
        }
        if ((filter.active || filter.hasSelection) && filter.selected_values) {
          filter.selected = filter.selected || {};
          filter.selected_values.forEach(value => {
            // validar si están dentro del rango
            const valueMinInRange = value.min >= filter.value[value.id].min && value.min <= filter.value[value.id].max;
            const valueMaxInRange = value.max >= filter.value[value.id].min && value.max <= filter.value[value.id].max;
            if (valueMinInRange && valueMaxInRange) {
              filter.selected![value.id] = {
                min: value.min,
                max: value.max,
                minFormatted: filter.value_type == "TIME" ? this.minutesToTime(value.min) : `${this.translateService.instant('filters.range.min')} ${this.formatPrice(value.min)}`,
                maxFormatted: filter.value_type == "TIME" ? this.minutesToTime(value.max) : `${this.translateService.instant('filters.range.max')} ${this.formatPrice(value.max)}`
              }
            }
          });
        }
      }
    });
  }

  isVacationRentalsLanding(): boolean {
    const maybeNevoModule = this.landingModel.modules
      .find(module => module.id === 'NevoModule');

    return maybeNevoModule && maybeNevoModule.data && maybeNevoModule.data.product === 'vr';
  }

  onApplyFilters(filterIndex?): void {
    this.closeTooltip(filterIndex);
    Object.entries(this.module.data.filters).forEach(([key, filter]) => {
      let label: string | undefined
      if (filter.type === 'discrete') {
        label = filter.values?.find(value => value.selected)?.name;
        if (filter.search_type === FilterType.CITY && label) {
          this.cityFilter = {
            showCity: true,
            cityName: label
          }
        }
      }
    });
    this.selectedFilterLabels = this.filtersService.getSelectedFilterLabels();
  }

  closeTooltip(filterIndex?) {
    const tooltipComponent = filterIndex >= 0 ? this.individualFilterTooltips.get(filterIndex) : this.tooltipComponent;
    if (tooltipComponent?.isOpen) {
      tooltipComponent.toggleOpen();
    }
  }

  onRemoveFiltersEvent(): void {
    this.module.data.filters = JSON.parse(JSON.stringify(this.initialFilters));
    this.filtersService.registerFilters(this.module.data.filters);
    this.selectedFilterLabels = {};
    this.cityFilter = {
      showCity: this.module.data.show_origin,
      cityName: this.module.data.default_origin,
    }
  }

  getLabelText(filterEntry: KeyValue<string, Filter>): string {
    return this.selectedFilterLabels[filterEntry.key]?.label || filterEntry.value.name;
  }

  configMapLink(): void {
    if (this.module.data.city_gid) {
      const linkProduct = this.isVacationRentalsLanding() ? 'vacation-rentals' : 'accommodations';
      const fromDate = OffersFiltersComponent.resolveMapLinkFromDate();
      const toDate = OffersFiltersComponent.resolveMapLinkToDate();
      const viewMode = this.module.id === 'HotelFiltersModule' ? 'hybrid' : 'map';

      this.mapLink = `/${linkProduct}/results/${this.module.data.city_gid}/${fromDate}/${toDate}/2?viewMode=${viewMode}`;
    }
  }

  showFilters(filterEntry: KeyValue<string, Filter>) {

    if (filterEntry.value.hidden && !this.filtersService.isForcedVisible(filterEntry.value.name)) return;

    if (this.module.data.use_modal) {
      if (filterEntry.value.group_id) {
        this.showFiltersModal(undefined, filterEntry.value.group_id);
      } else {
        this.showFiltersModal(filterEntry.value.name);
      }
      return;
    }

    if (filterEntry.key === 'flexible_cancellation_policy') {
      this.applyFlexFilter(filterEntry.key, filterEntry.value as DiscreteFilter);
    } else if (!this.isDesktop) {
      this.showFiltersModal();
    }
  }

  showFiltersModal(clickedFilterName?: string, clickedGroupId?: string) {
    this.modalFooterModel = {
      customStyles: { 'flex-direction': 'row-reverse', 'justify-content': 'flex-start' },
      acceptCallback: () => {
        this.filtersService.applyModalFilters(this.isImprovedFiltersEnabled);
      },
      cancelCallback: () => {
        this.filtersService.emptyAllFilters();
        this.filtersService.unapplyAllFilter(this.module.row_number, this.module.unique_id, this.isImprovedFiltersEnabled);
      },
      acceptLabel: this.translateService.instant('common.apply'),
      cancelLabel: this.translateService.instant('common.deleteAll'),
      cancelButtonType: '-white',
      moduleId: this.module.id,
      moduleIndex: this.module.row_number,
      uniqueId: this.module.unique_id,
      size: globalThis.innerWidth <= 340 ? '-md' : '-lg',
      modelChanges: new EventEmitter(),
      acceptButtonDisabled: true,
      isCancelable: this.filtersService.countFiltersApplied(),
    }

    this.modalService.showModal({
      id: 'offers-filters-modal',
      title: this.translateService.instant('common.filter'),
      product: 'nymeria-gui',
      flow: 'landing',
      isWebview: this.isWebview,
      contentComponent: OffersFiltersModalContentComponent,
      contentModel: {
        dataFilters: this.module.data,
        currency: this.currency,
        moduleIndex: this.module.row_number,
        moduleId: this.getModuleId(),
        clickedFilterName: clickedFilterName,
        clickedGroupId: clickedGroupId,
        isMobile: !this.isDesktop,
        isModal: this.module.data.use_modal,
      },
      footerComponent: ConfirmButtonsComponent,
      footerModel: this.modalFooterModel
    });
  }

  needColumns(filterEntry: KeyValue<string, Filter>): boolean {
    const filter = filterEntry.value;
    return filter.type === 'discrete' && !!filter.values && filter.values.length > 10;
  }

  removeFilter(filterEntry: KeyValue<string, any>) {
    delete this.selectedFilterLabels[filterEntry.key];
    this.filtersService.unapplyFilter(filterEntry.key, this.module.row_number, this.module.unique_id, this.isImprovedFiltersEnabled);
    
  }

  removeAllFilters() {
    this.filtersService.emptyAllFilters();
    this.filtersService.unapplyAllFilter(this.module.row_number, this.module.unique_id, this.isImprovedFiltersEnabled);
    this.module.data.filters = UtilsService.copy(this.module.data.filters);
  }

  private applyFlexFilter(key: string, value: DiscreteFilter) {
    if (!value.hasSelection) {
      value.hasSelection = true;
      value.values.forEach(val => val.selected = true);
      this.filtersService.updateFilterParams(this.module.row_number, this.module.unique_id);
      this.filtersService.applyFilter(this.isImprovedFiltersEnabled);
    }
  }

  getModuleId() {
    return 'OffersFiltersModule';
  }

  trackViewOnMap() {
    this.upaService.trackClickTopic({
      label: this.translateService.instant(`common.view-on-map.${this.screenType}`),
      moduleId: this.getModuleId(),
      moduleIndex: this.module.row_number,
      target: UpaTarget.BUTTON,
      href: this.mapLink,
      uniqueId: this.module.unique_id
    });
  }

  // Scroll
  public onScroll(): void {
    if (!this.isDesktop || !this.module.data.use_modal) return;

    var left = this.scrollContent.nativeElement.scrollLeft;
    var sWidth = this.scrollContent.nativeElement.scrollWidth;
    var oWidth = this.scrollContent.nativeElement.offsetWidth;
    // Left arrow
    if (left === 0)
      this.hideArrow(this.leftArrow);
    else
      this.showArrow(this.leftArrow);
    // Right arrow
    let total = oWidth + left;
    if (total >= sWidth)
      this.hideArrow(this.rightArrow);
    else
      this.showArrow(this.rightArrow);
  }

  public onClickScrollRight(): void {
    this.doScroll(this.scrollContent.nativeElement.scrollLeft + this.distance);
  }

  public onClickScrollLeft(): void {
    this.doScroll(this.scrollContent.nativeElement.scrollLeft - this.distance);
  }

  private doScroll(distance: number): void {
    this.scrollContent.nativeElement.scrollTo({
      left: distance,
      behavior: 'smooth'
    });
  }

  private showArrow(arrow: ElementRef): void {
    arrow.nativeElement.classList.remove('hide');
  }
  private hideArrow(arrow: ElementRef): void {
    arrow.nativeElement.className += ' hide';
  }

  private initGroupedFilters() {
    Object.entries(this.module.data.filters).forEach(([key, filter]) => {
      if (filter.group_id) {
        this.groupedFilters[filter.group_id] = this.groupedFilters[filter.group_id] || {};
        this.groupedFilters[filter.group_id][key] = filter;
      }
    });
  }

  getGroupLabelText(groupId) {
    return this.selectedFilterLabels[groupId]?.label || groupId;
  }

  someGroupedFilterSelected(groupId) {
    return Object.values(this.groupedFilters[groupId]).some(filter => filter.hasSelection || filter.active);
  }

  showGroupedFilters(groupId) {
    const firstGroupFilter = Object.values(this.groupedFilters[groupId])[0];
    const filterEntry: KeyValue<string, Filter> = { key: firstGroupFilter.name, value: firstGroupFilter };
    this.showFilters(filterEntry);
  }

  removeGroupedFilter(groupId) {
    delete this.selectedFilterLabels[groupId];
    this.filtersService.unapplyFilterGroup(groupId, this.module.row_number, this.module.unique_id, this.isImprovedFiltersEnabled);
  }

  onAlertButtonClick() {
    this.priceAlertsService.saveClickFlagOnLocalStorage();
    this.priceAlertsService.openAlerts();
  }

  get isImprovedFiltersEnabled(): boolean {
    return this.improvedFiltersEnabled;
  }

  hasSortingOptions(): boolean {
    return this.isImprovedFiltersEnabled && this.module?.data?.sorting_options != null && this.module.data.sorting_options.length > 0;
  }

  onSortingChange(selectedOption: any): void {
    this.module.data.sorting_options.forEach(option => {
      option.selected = option.id === selectedOption.id;
    });

    this.filtersService.applySorting(selectedOption.id, this.module.row_number, this.module.unique_id, this.isImprovedFiltersEnabled);
  }

  showSortingModal(): void {
    this.modalService.showModal({
      id: 'sorting-modal',
      title: this.translateService.instant('common.sort'),
      product: 'nymeria-gui',
      flow: 'landing',
      isWebview: this.isWebview,
      contentComponent: SortingModalContentComponent,
      contentModel: {
        sortingOptions: this.module.data.sorting_options,
        sortingChangeCallback: (selectedOption: any) => {
          this.onSortingChange(selectedOption);
          this.modalService.closeModal();
        }
      }
    });
  }
}
